var exports = {
  "kL": "MatureContentChannelGate.module__container___bUtxen",
  "Qs": "MatureContentChannelGate.module__content___bUtxen",
  "DD": "MatureContentChannelGate.module__title___bUtxen",
  "h_": "MatureContentChannelGate.module__description___bUtxen",
};

module.exports = exports;
